<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info">
              <v-toolbar-title>{{ $t('Transfer-Name-List') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB == 'TRY'">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="report-filter-card">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md2 pt-2>
                        <tarihcomp
                          :etiket="$t('Starting-Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla"
                          v-model="KayitTarihiBasla"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <tarihcomp
                          :etiket="$t('Finishing-Date')"
                          :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]"
                          v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis"
                          v-model="KayitTarihiBitis"
                        ></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <genelarama
                          :autofocuss="true"
                          apiname="SaticiAra"
                          :label="$t('Seller-Code')"
                          v-model="Satici"
                        ></genelarama>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <genelarama
                          apiname="SaticiAra"
                          :tip="12"
                          :label="$t('Tour-Operator')"
                          v-model="turOperatoru"
                        ></genelarama>
                      </v-flex>

                      <v-flex xs12 sm6 md2 pt-2>
                        <pnrbul
                          v-model="searchPnrNo"
                          :rules="[(v) => !!v || $t('Mandatory-section')]"
                          hide-details
                        ></pnrbul>
                      </v-flex>

                      <v-flex xs12 sm6 md1 pt-2 class="d-flex align-center">
                        <v-checkbox
                          v-model="searchOzet"
                          :label="$t('Summary-List')"
                          hide-details
                        ></v-checkbox>
                      </v-flex>

                      <v-flex xs12 sm12 md1 pt-2 class="d-flex align-center justify-center">
                        <div v-if="load1">
                          <v-btn color="info" @click="getList()" fab small dark>
                            <v-icon>search</v-icon>
                          </v-btn>
                        </div>

                        <div v-if="progress">
                          <v-layout align-center>
                            <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="headers"
                    :items="itemssatis"
                    :loading="progress"
                    :has-searched="hasSearched"
                    :storage-key="'transferisimlistesi_report_table_v2'"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :rows-per-page-items="[20, 50, 100, 200]"
                    class="report-table-host"
                  >
                    <template slot="cell" slot-scope="slotProps">
                      <div
                        class="cell-click-area"
                        @click="onCellClick(slotProps.item, slotProps.column)"
                      >
                        <template v-if="slotProps.column.value === 'PNR_No'">
                          <a
                            href="#"
                            @click.prevent.stop="pnrGit(slotProps.item.PNR_No)"
                            class="pnr-link"
                          >
                            {{ slotProps.item.PNR_No }}
                          </a>
                        </template>

                        <template v-else-if="slotProps.column.value === 'AracRehber'">
                          {{ slotProps.value ? slotProps.value.split('+')[0] : '' }}
                        </template>

                        <template v-else>
                          {{ slotProps.value }}
                        </template>
                      </div>
                    </template>
                  </ReportTable>
                </v-flex>

                <v-dialog v-model="dialogupdate" scrollable persistent max-width="500px">
                  <v-card flat color="grey lighten-4">
                    <v-card-title>{{ $t('Update') }}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md12 pa-1>
                          <v-card flat class="white--text">
                            <v-card flat color="grey lighten-5">
                              <v-card-actions>
                                <v-layout row wrap>
                                  <v-flex xs11 sm11 md11>
                                    <genelarama
                                      :autofocuss="true"
                                      apiname="SaticiAra"
                                      tip="2"
                                      :label="$t('Seller-Code')"
                                      v-model="UpdatePrm.SaticiKod"
                                    ></genelarama>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1>
                                    <v-layout row wrap fill-height align-end justify-center>
                                      <minisaticieklecomp
                                        v-model="UpdatePrm.SaticiKod"
                                        :label="$t('Add-transfer-Seller')"
                                        saticiKod="2"
                                      ></minisaticieklecomp>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                    <genelarama
                                      :autofocuss="true"
                                      apiname="SaticiAra"
                                      tip="1"
                                      :label="$t('Hotel')"
                                      v-model="UpdatePrm.OtelKod"
                                    ></genelarama>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1>
                                    <v-layout row wrap fill-height align-end justify-center>
                                      <minisaticieklecomp
                                        v-model="UpdatePrm.OtelKod"
                                        :label="$t('Add-hotel-Seller')"
                                        saticiKod="1"
                                      ></minisaticieklecomp>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm6 md12>
                                    <v-flex xs12 sm6 md12>
                                      <aracalanara
                                        :saticikodu="UpdatePrm.SaticiKod"
                                        v-model="UpdatePrm.Arac"
                                      ></aracalanara>
                                    </v-flex>
                                  </v-flex>

                                  <v-flex xs11 sm11 md11>
                                    <genelarama
                                      :autofocuss="true"
                                      apiname="SaticiAra"
                                      tip="6"
                                      :label="$t('Guide')"
                                      v-model="UpdatePrm.Rehber"
                                    ></genelarama>
                                  </v-flex>

                                  <v-flex xs1 sm1 md1>
                                    <v-layout row wrap fill-height align-end justify-center>
                                      <minisaticieklecomp
                                        v-model="UpdatePrm.Rehber"
                                        :label="$t('Add-guide-Seller')"
                                        saticiKod="6"
                                      ></minisaticieklecomp>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <v-text-field
                                      v-model="UpdatePrm.TurKodu"
                                      :label="$t('Tour-Code')"
                                    ></v-text-field>
                                  </v-flex>

                                  <tasimatipi v-model="UpdatePrm.TasimaTipi"></tasimatipi>

                                  <v-flex xs12 sm12 md12>
                                    <v-text-field
                                      v-model="UpdatePrm.UcusSaat"
                                      :label="$t('Flight-Time')"
                                      type="text"
                                      mask="##:##"
                                      placeholder="HH:mm"
                                      clearable
                                      return-masked-value
                                      maxlength="5"
                                    ></v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <v-text-field
                                      v-model="UpdatePrm.Saat"
                                      :label="$t('Hour')"
                                      type="text"
                                      mask="##:##"
                                      placeholder="HH:mm"
                                      clearable
                                      return-masked-value
                                      maxlength="5"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="updateiptal()">
                        {{ $t("cancel_button") }}
                      </v-btn>
                      <v-btn color="blue darken-1" flat @click.native="updatekayit()">
                        {{ $t('Apply') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{ $t('Close') }}</v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../tools";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import anatip from "@/components/app/coper/comp/anatip.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp";
import tasimatipi from "@/components/app/coper/component/tasimatipi.vue";
import aracalanara from "@/components/app/coper/component/aracalanara.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";

export default {
  data() {
    return {
      headers: [],
      itemssatis: [],
      saticiitems: [],
      otelitems: [],
      aracitems: [],
      rehberitems: [],
      turkoduitems: [],
      menu1: false,
      searchOzet: false,
      hasSearched: false,

      UpdatePrm: {
        IslemRef: 0,
        UcusSaat: null,
        Saat: null,
        Rehber: "",
        SaticiKod: "",
        OtelKod: "",
        Arac: "",
        Tip: "",
        TasimaTipi: "",
        TurKodu: ""
      },

      PB: "TRY",
      Satici: null,
      tumsirketler: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      searchPnrNo: null,
      turOperatoru: null,
      KayitTarihiBasla: null,
      KayitTarihiBitis: null,
      SaticiKodu: null,

      valid: true,
      loading: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      renk1: "info",
      dialogupdate: false,
      searchcari: "",
      progress: false,
      tooltip: false,
      el: null,
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      dictionary: {
        custom: {
          tarihsec: {
            required: () => this.$t("Please-select-a-date")
          },
          tarihsec1: {
            required: () => this.$t("Please-select-a-date")
          }
        }
      }
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path;
    });
  },

  beforeMount: beforeMount,

  mounted() {
    this.headers = createHeaders(this);

    this.getOtelItems();
    this.getSaticiItems();
    this.getaracItems();
    this.getrehberItems();

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    this.PB = credentials.ParaBirimi;

    this.$validator.localize("en", this.dictionary);

    var params = {
      CompanyCode: credentials.SirketKodu
    };

    this.$http
      .post(auth.API_URL + "api/currency/List", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      })
      .then(
        response => {
          this.doviztipi = response.body;
        },
        () => {
                this.text1 = this.$t("Currency-List-Could-Not-Be-Retrieved");
          this.snackbar = true;
        }
      );
  },

  filters: {
    dateformat: function(t) {
      return helpers.dateformat(t);
    },
    moneyformat: function(m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function(m) {
      return helpers.bakiyekontrol(m);
    }
  },

  components: {
    tarihcomp,
    yetkidialog,
    hatadialog,
    anatip,
    genelarama,
    referansmerkezicomp,
    pnrbul,
    cariaracomp,
    tasimatipi,
    aracalanara,
    minisaticieklecomp,
    ReportTable
  },

  methods: {
    onCellClick(item, column) {
      if (!item || !column) {
        return;
      }

      if (column.value === "PNR_No") {
        return;
      }

      this.git(item);
    },

    pnrGit(val) {
      var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
      window.open(url, "_target");
    },

    getaracItems() {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm).then(
        response => {
          this.aracitems = response.body;
        },
        () => {}
      );
    },

    getrehberItems() {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 6,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm).then(
        response => {
          this.rehberitems = response.body;
        },
        () => {}
      );
    },

    getOtelItems() {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm).then(
        response => {
          this.otelitems = response.body;
        },
        () => {}
      );
    },

    getSaticiItems() {
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis: 0
      };

      tool.http_post(this, "SaticiAra", prm).then(
        response => {
          this.saticiitems = response.body;
        },
        () => {}
      );
    },

    turkodugetir(SaticiKod) {
      var params = {
        SaticiKodu: SaticiKod
      };

      tool.http_post(this, "AcenteTurlar", params).then(
        response => {
          this.turkoduitems = response.body.data;
        },
        () => {
          this.text1 = this.$t("Location-could-not-found-error-occured");
          this.snackbar = true;
        }
      );
    },

    updateiptal() {
      this.dialogupdate = false;
    },

    updatekayit() {
      if (this.UpdatePrm.Tip == "") this.UpdatePrm.Tip = null;
      if (this.UpdatePrm.TasimaTipi == "") this.UpdatePrm.TasimaTipi = null;
      if (this.UpdatePrm.OtelKod == "") this.UpdatePrm.OtelKod = null;
      if (this.UpdatePrm.Arac == "") this.UpdatePrm.Arac = null;
      if (this.UpdatePrm.Rehber == "") this.UpdatePrm.Rehber = null;
      if (this.UpdatePrm.Saat == "") this.UpdatePrm.Saat = null;
      if (this.UpdatePrm.UcusSaat == "") this.UpdatePrm.UcusSaat = null;

      if (this.UpdatePrm.Rehber && this.UpdatePrm.Rehber.kod) {
        this.UpdatePrm.Rehber = this.UpdatePrm.Rehber.kod;
      } else {
        this.UpdatePrm.Rehber = "";
      }

      if (this.UpdatePrm.OtelKod && this.UpdatePrm.OtelKod.kod) {
        this.UpdatePrm.OtelKod = this.UpdatePrm.OtelKod.kod;
      } else {
        this.UpdatePrm.OtelKod = "";
      }

      if (this.UpdatePrm.SaticiKod && this.UpdatePrm.SaticiKod.kod) {
        this.UpdatePrm.SaticiKod = this.UpdatePrm.SaticiKod.kod;
      } else {
        this.UpdatePrm.SaticiKod = "";
      }

      tool.http_post(this, "TransferIsimListesiUpdateControl", this.UpdatePrm).then(
        response => {
          this.dialogupdate = false;
          this.getList();

          if (!response.body.status) {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        () => {
          this.text1 = this.$t("Location-could-not-found-error-occured");
          this.snackbar = true;
        }
      );
    },

    HataYonetimi(response, request, baslik) {
      if (response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    git(val) {
      var rehberprm = null;
      if (val.Rehber) {
        rehberprm = {
          kod: val.Rehber,
          id: "0",
          isim: val.RehberAd,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      var otelprm = null;
      if (val.OtelKod) {
        otelprm = {
          kod: val.OtelKod,
          id: "0",
          isim: val.OtelAd,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      var saticiprm = null;
      if (val.SaticiKod) {
        saticiprm = {
          kod: val.SaticiKod,
          id: "0",
          isim: val.SaticiAd,
          isimAra: "",
          YurtIci_YurtDisi: "",
          CariKod: "",
          KDV: 0
        };
      }

      this.UpdatePrm.UcusSaat = val.UcusSaatStr;
      this.UpdatePrm.IslemRef = val.IslemRef;
      this.UpdatePrm.Saat = val.SaatStr;
      this.UpdatePrm.Tip = val.Tip;
      this.UpdatePrm.TasimaTipi = val.TasimaTipi;
      this.UpdatePrm.TurKodu = val.TurKodu;
      this.UpdatePrm.OtelKod = otelprm;
      this.UpdatePrm.Arac = val.Arac;
      this.UpdatePrm.Rehber = rehberprm;
      this.UpdatePrm.SaticiKod = saticiprm;

      this.turkodugetir(val.SaticiKod);
      this.dialogupdate = true;
    },

    getList,
    getListExcel
  }
};

function getList() {
  var saticiprm = null;
  if (this.Satici != null) {
    saticiprm = this.Satici.kod;
  }

  var operatorprm = null;
  if (this.turOperatoru != null) {
    operatorprm = this.turOperatoru.kod;
  }

  var params = {
    Tarih1: this.KayitTarihiBasla,
    Tarih2: this.KayitTarihiBitis,
    SaticiKod: saticiprm,
    OperatorKod: operatorprm,
    PNR_No: this.searchPnrNo,
    Ozet: this.searchOzet
  };

  this.hasSearched = true;
  this.progress = true;
  this.load1 = false;

  tool.http_post(this, "TransferIsimListesi", params).then(
    response => {
      if (response.body.Status == true) {
        this.itemssatis = response.body.data || [];
        this.progress = false;
        this.load1 = true;
      } else {
        this.itemssatis = [];
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
        this.progress = false;
        this.load1 = true;
      }
    },
    response => {
            this.HataYonetimi(response, params, this.$t("Transfer-Name-List-Could-Not-Be-Retrieved"));
      this.progress = false;
      this.load1 = true;
    }
  );
}

function getListExcel() {
  var saticiprm = null;
  if (this.Satici != null) {
    saticiprm = this.Satici.kod;
  }

  var operatorprm = null;
  if (this.turOperatoru != null) {
    operatorprm = this.turOperatoru.kod;
  }

  var params = {
    Tarih1: this.KayitTarihiBasla,
    Tarih2: this.KayitTarihiBitis,
    SaticiKod: saticiprm,
    OperatorKod: operatorprm,
    PNR_No: this.searchPnrNo,
    Ozet: this.searchOzet
  };

  tool.api_post_FileDownload(this, "Coper/ExcelTransferIsimListesi", params).then(
    response => {
      tool.CreateDownloadLink(response, "ExcelTransferIsimListesi.xlsx");
    },
    () => {}
  );
}

function createHeaders(vm) {
  return [
    { text: vm.$t("Reservation-Code"), value: "RezzKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
{ text: vm.$t("Tour-Code"), value: "TurKodu", type: "text", align: "left", visible: true, sortable: true, minWidth: "160px" },
{ text: vm.$t("Adult"), value: "ADT", type: "text", align: "left", visible: true, sortable: true, minWidth: "100px" },
{ text: vm.$t("Period-v2") + " 1", value: "Donem1", type: "date", align: "left", visible: true, sortable: true, minWidth: "140px" },
{ text: vm.$t("Guide") + " " + vm.$t("Name"), value: "RehberAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Vehicle-Plate-Code-Number"), value: "AracRehber", type: "text", align: "left", visible: true, sortable: true, minWidth: "160px" },
{ text: vm.$t("Description"), value: "Aciklama", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
{ text: vm.$t("PNR_No"), value: "PNR_No", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
{ text: vm.$t("Flight-Time"), value: "UcusSaatStr", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Hour"), value: "SaatStr", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("From"), value: "Nerden", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
{ text: vm.$t("To"), value: "Nereye", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px" },
{ text: vm.$t("Transfer_lbl"), value: "Arac", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
{ text: vm.$t("Flight-No"), value: "UcusNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("PIN-Code"), value: "PINCode", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Adult") + " " + vm.$t("Pax"), value: "YetiskinPax", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("Child") + " 1 " + vm.$t("Pax"), value: "Cocuk1Pax", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("Child") + " 2 " + vm.$t("Pax"), value: "Cocuk2Pax", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("Process-Ref"), value: "IslemRef", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Pax"), value: "Pax", type: "text", align: "left", visible: true, sortable: true, minWidth: "90px" },
{ text: vm.$t("Name"), value: "Isim", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
{ text: vm.$t("Agency-Name"), value: "AcenteAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
{ text: vm.$t("Hotel-Code"), value: "OtelKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Hotel-Name"), value: "OtelAd", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px" },
{ text: vm.$t("Seller-Code"), value: "SaticiKod", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
{ text: vm.$t("Tour-Operator"), value: "TurOperatoru", type: "text", align: "left", visible: true, sortable: true, minWidth: "160px" },
{ text: vm.$t("Ref"), value: "Ref", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px" },
{ text: vm.$t("Driver") + " " + vm.$t("Collection-Amount"), value: "SoforTahsilatTutar", type: "money", align: "left", visible: true, sortable: true, minWidth: "170px" },
{ text: vm.$t("Transfer_lbl") + " " + vm.$t("Status"), value: "strTransferDurumu", type: "text", align: "left", visible: true, sortable: true, minWidth: "170px" },
{ text: vm.$t("Current-Account-Code"), value: "Cari_Kod", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px" },
{ text: vm.$t("Guide") + " " + vm.$t("Code"), value: "Rehber", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px" },
   
  ];
}

function beforeMount() {}
</script>

<style scoped>
.report-filter-card {
  border: 1px solid #e6ebf0;
  background: #fff;
}

.report-table-host {
  width: 100%;
}

.cell-click-area {
  display: block;
  width: 100%;
  min-height: 24px;
  cursor: pointer;
}

.pnr-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.pnr-link:hover {
  text-decoration: underline;
}

.v-toolbar .v-btn {
  text-transform: none;
}
</style>